// ----------------------------------------------------------------------------
// Component: Footer
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/accordion/accordion';
import 'snippets/newsletter-form/newsletter-form';
import 'snippets/icon/icon';
import 'snippets/menu/menu';
import 'sections/email-signup/email-signup';

// Styles
import './_footer.scss';